import { useStrategiesContext } from './StrategiesContext';

import { Modal } from '../Modal';
import { ControlBar } from './ControlBar';
import { Compare } from './StrategiesActions/Compare';
import { View } from './StrategiesActions/View';
import { Align } from './StrategiesActions/Align';

// TODO improve
const list = {
  'Edit tags': 'Edit tags',
  Rename: 'Rename strategy',
  Duplicate: 'Duplicate strategy',
};

export const Dashboard = () => {
  const { element, option, strategiesOption, closeModal } =
    useStrategiesContext();

  const titleModal = Object.keys(list).includes(option!)
    ? list[option!]
    : undefined;

  return (
    <>
      <ControlBar />

      {strategiesOption === 'Strategies' && <View />}
      {strategiesOption === 'Compare' && <Compare />}
      {strategiesOption === 'Align' && <Align />}

      {element && (
        <Modal
          element={element || <></>}
          height={'auto'}
          handleMerlinLogo
          isOpen={typeof element !== 'undefined'}
          title={titleModal}
          onCloseClick={closeModal}
        />
      )}
    </>
  );
};
